import React from 'react';
import styles from '../../styles/flyouts/my_company_members/History.scss';
import { withRouter } from 'react-router';
import { dateTimeFrom } from '../../core/utils';
import classNames from 'classnames';

const History = ({ data, collapsed }) => {
  return (
    <div className={classNames(styles.scroller, collapsed && styles.collapsed)}>
      {_.map(data.history, (row, i) => (
        <div className={styles.row} key={i}>
          <div className={styles.heading}>
            <span>{row.title}</span>
            <span>
              {row.user} &middot; {dateTimeFrom(row.created_at)}
            </span>
          </div>
          {_.size(row.content) > 0 && (
            <div className={styles.content}>{row.content}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default History;
